import Accordion from './accordion';

//=============================================================================
// This will allow you to switch between visible and invisible sections.

// Add "js-switch-parent" class to the parent container.
// Add "js-switch-link" class to nav links used to switching.
// Add "js-switch-section" class to sections to switch.
// Add matching data-type attributes to the matching links and sections.

// Show and hide elements with a "hidden" class.

// If you want to only switch on mobile sizes, you can use the "mobile-hidden"
// Add data-mobile-switcher="true" to the parent.
//=============================================================================


export default class SectionSwitcher {
  //===========================================================================
  // Constructor
  //===========================================================================

  constructor(init) {
    if (init) {
      this.state = {
        accordion: new Accordion()
      };

      this.setupEventListeners();
    }
  }

  //===========================================================================
  // Switches the section based on link clicks
  //===========================================================================

  switchSectionOnLinkClick(e) {
    const $target = $(e.currentTarget);

    if ($target.is('a')) {
      e.preventDefault();
    }

    this.switchSection($target);
  }

  //===========================================================================
  // Switches the section
  //===========================================================================

  switchSection($target) {
    const $parent     = $target.closest('.js-switch-parent');
    const $links      = $parent.find('.js-switch-link').not($parent.find('.js-switch-parent .js-switch-link'));
    const $sections   = $parent.find('.js-switch-section').not($parent.find('.js-switch-parent .js-switch-section'));
    const sectionType = $target.data('type');
    const hiddenClass = !!$parent.data('mobile-switcher') ? 'mobile-hidden' : 'hidden';

    if ($target.hasClass('js-switch-accordion-tab') && $target.hasClass('active')) {
      setTimeout(() => {
        $links.removeClass('active');
      }, 400);
    } else {
      $links.removeClass('active');
      $links.filter(`[data-type="${ sectionType }"]`).addClass('active');
    }

    this.switchTitle($target, $parent);

    $sections.each((i, section) => {
      let $section = $(section);

      if ($section.data('type') === sectionType) {
        $section.removeClass(hiddenClass);
      } else {
        $section.addClass(hiddenClass);
      }
    });
  }

  //===========================================================================
  // Switches the title if data-update-title is set to true on the parent
  //===========================================================================

  switchTitle($target, $parent) {
    const sectionType = $target.data('type');

    if (sectionType && !!$parent.data('update-title')) {
      $parent.find('.js-switch-title').text(sectionType);
    }
  }

  //===========================================================================
  // Deactivates an active section tab
  //===========================================================================

  deactivateSectionTabs(e) {
    const $target = $(e.currentTarget);
    const $parent = $target.closest('.js-switch-parent');
    const $tabs   = $parent.find('.js-switch-accordion-tab');
    const delay   = $target.data('delay') ? Number($target.data('delay')) : 0;

    setTimeout(() => {
      this.state.accordion.closeAccordionOnClick(e);

      setTimeout(() => {
        $tabs.removeClass('active');
      }, 400);
    }, delay);
  }

  //===========================================================================
  // Switches fade in/out sections
  //===========================================================================

  switchFadeSection(e) {
    const $target   = $(e.currentTarget);
    const $parent   = $target.closest('.js-switch-fade-parent');
    const $sections = $parent.find('.js-switch-fade-section, .js-switch-fade-link');
    const sectionId = $target.data('type');

    if ($target.is('a')) {
      e.preventDefault();
    }

    $sections.each((i, section) => {
      let $section = $(section);

      if ($section.data('type') === sectionId) {
        $section.addClass('active');
      } else {
        $section.removeClass('active');
      }
    });
  }

  //===========================================================================
  // Sets up event listeners
  //===========================================================================

  setupEventListeners() {
    $(document).on('click', '.js-switch-link', this.switchSectionOnLinkClick.bind(this));
    $(document).on('click', '.js-deactivate-tabs', this.deactivateSectionTabs.bind(this));
    $(document).on('click', '.js-switch-fade-link', this.switchFadeSection.bind(this));
  }
}
